/*jshint forin:true, noarg:true, noempty:true, eqeqeq:true, bitwise:true, strict:true, undef:true, unused:true, browser:true, devel:true, jquery:true, indent:4, maxerr:50, boss:true, trailing:true, white:true, sub:true */

/**
*
* jQuery Estee Lauder products plugin
*
*   A jQuery plugin to populate content based on the presence of a template or non-templated product carousel.
*
* @version 2.0.2.2
* @author Stephen Tetreault <stephen.tetreault@firefallpro.com>
* @link http://www.firefallpro.com/
* @license http://www.firefallpro.com/license.txt
* @copyright Copyright (c) 2015 Firefall Pro, LLC
*
* * Whats new in 2.0.2.2:
* Updated data() handling so script works better with dynamically created elements
* Unit Price Handling
*
* Whats new in 2.0.2.1:
* Complete usage of productMap object over array iteration
*
*/
(function ($) {
  'use strict';

  /**
  * The default configuration, and available options to configure with.
  *
  * @name $.fn.elproduct.defaults
  * @namespace
  * @property {string} [rpc_url=/rpc/response.tmpl?JSONRPC=] The full URL that we send a GET request to.
  * @property {string} [plugin_name=jquery.elproduct] The plugin name.
  * @property {object} [class_map={}] A mapping for all the classes referenced, updated within the carousel/scope.
  */
  var defaults = {
    rpc_url : '/rpc/response.tmpl?JSONRPC=',
    prod_array : [],
    sku_array : [],
    productMap: {},
    wrappers: [],
    callback : (function() {}),
    plugin_name : 'jquery.elproduct',
    class_map : {
      target : '.el-product',
      image_container : '.el-product_image-container',
      image : '.el-product_image',
      category : '.el-product_category',
      name : '.el-product_name',
      subhead : '.el-product_rgn-subheading',
      alt_description : '.el-product_alt_description-text',
      description : '.el-product_description-text',
      price : '.el-product_price',
      unit_price: '.el-product_unit_price',
      quickshop : '.el-product_shop-now',
      rating_star_container : '.el-product_stars-rating',
      rating_star_element :  '.el-product_stars-rating span',
      review_count: '.el-product_review-count',
      hidden_field_template_selector : '.products_hidden_field .el-product',
      shade_name: '.el-product_shadename'
    },
    query : [{
      method : 'prodcat.querykey',
      params : [{
        query_key : 'tout-mpp-product',
        products : []
      }]
    }]
  };

  /**
  * This is the object that holds all the methods used in $.fn.elproduct and $.fn.elproduct.query
  * @namespace $.fn.elproduct.methods
  */
  var methods = {
    /**
    *
    * Execute query to get RPC data
    *
    * @memberof $.fn.elproduct.methods
    * @function _query
    * @param {object} Holds the non-serialized JSON for the RPC query. If undefined use the JSON query created through _fetch_products.
    * @param {object} Options for this query function, which should contain a callback or flag.
    * @returns {object} Returns the Promise that holds the async call.
    *
    */
    '_query' : function (extended_object) {
      // add product IDs to the Query's product array
      extended_object.query[0].params[0].products = extended_object.prod_array;

      // notify
      if (extended_object.debug) {
        console.log('_query() function');
        console.log(extended_object.rpc_url + JSON.stringify(extended_object.query));
      }

      // set up promise
      var promise = $.getJSON(extended_object.rpc_url + JSON.stringify(extended_object.query));

      // if the query fails, notify us.
      promise.fail(function() {
        if (extended_object.debug) console.log('RPC Query has failed.');
        if (typeof extended_object.onError !== 'undefined') extended_object.onError();
        return;
      }).done(function(data) {
        // if the query is done, sometimes it returns with an error. Notify us.
        // if the query truly succeeds, run _post_query_insertion().
        if (data[0].hasOwnProperty('error'))  {
          if (extended_object.debug) console.log('RPC Query has returned with an error.');
          if (typeof extended_object.onError !== 'undefined') extended_object.onError();
          return;
        } else {
          methods._post_query_insertion(extended_object, data);
        }
      });
    },
    /**
    *
    * The RPC query has succeeded, we want to now inject content into our carousel.
    *
    * @memberof $.fn.elproduct.methods
    * @function _handle_rpc_write_success
    * @param {object} data - Represents the returned JSON object from the RPC query.
    * @param {object} callback - Represents the callback (if provided) to be carried out when complete.
    */
    '_post_query_insertion' : function (extended_object, data) {
      var emptyProductData = {
        'full' : undefined,
        'id' : '',
        'quickshop_url' : '',
        'image' : '',
        'category_id' : '',
        'category' : '',
        'name' : '',
        'subhead' : '',
        'alt_description' : '',
        'description' : '',
        'price' : '$0.00',
        'unit_price' : '$0.00',
        'review_count' : 0,
        'average_rating' : 0,
        'average_rating_class_suffix' : '0_0',
        'shade_name' : '',
        'shade_hex' : ''
      };
      var $targets = [];
      var products = data[0].result.value.products; // Products received from API
      var product;
      var productAlternate;
      var $this;
      var productID;
      var sku;
      var resultData;
      var p = 0;
      var s = 0;
      var y = 0;

      // notify
      if (extended_object.debug) {
        console.log('_post_query_insertion() function');
        console.log('products', extended_object.productMap);
      }

      // if no data returned somehow (which can happen) then we return
      if (data[0].result.value === null) {
        if (extended_object.debug) console.log('ERROR: Products array is null, returning now.');
        extended_object.onError();
        return;
      }

      for(p = 0; p < products.length; p++) {
        product = products[p];
        productID = product.PRODUCT_ID;

        if (typeof extended_object.productMap[productID] !== 'undefined') {

          // Set base product data to inject
          extended_object.productMap[productID].data = {
            'full' : product,
            'prod_id' : product.PRODUCT_ID,
            'sku_id' : '',
            'quickshop_url' : (typeof  product.url !== 'undefined' && product.url !== null) ? product.url : '',
            'image' : (typeof product.skus[0].LARGE_IMAGE !== 'undefined' && product.skus[0].LARGE_IMAGE !== null) ? product.skus[0].LARGE_IMAGE[0] : '',
            'category_id' : (typeof product.DEFAULT_CAT_ID !== 'undefined' && product.DEFAULT_CAT_ID !== null) ? product.DEFAULT_CAT_ID.substr(3) : '',
            'category' :  (typeof product.ATTRIBUTE_COLLECTION !== 'undefined' && product.ATTRIBUTE_COLLECTION !== null) ? product.ATTRIBUTE_COLLECTION : '',
            'name' : (product.PROD_RGN_NAME !== null && product.PROD_RGN_NAME !== null) ? product.PROD_RGN_NAME : '',
            'subhead' : (product.PROD_RGN_SUBHEADING !== null && product.PROD_RGN_SUBHEADING !== null) ? product.PROD_RGN_SUBHEADING : '',
            'alt_description' : (typeof product.ATTRIBUTE_DESC_1 !== 'undefined' && product.ATTRIBUTE_DESC_1 !== null) ? product.ATTRIBUTE_DESC_1 : '',
            'description' : (typeof product.PRODUCT_DETAILS_MOBILE !== 'undefined' && product.PRODUCT_DETAILS_MOBILE !== null) ? product.PRODUCT_DETAILS_MOBILE : '',
            'price' : (typeof product.skus[0].formattedPrice !== 'undefined' && product.skus[0].formattedPrice !== null) ? product.skus[0].formattedPrice : '$0.00',
            'unit_price' : (typeof product.skus[0].formattedUnitPrice !== 'undefined' && product.skus[0].formattedUnitPrice !== null) ? product.skus[0].formattedUnitPrice : '$0.00',
            'review_count' : (typeof product.TOTAL_REVIEW_COUNT !== 'undefined' && product.TOTAL_REVIEW_COUNT !== null) ? product.TOTAL_REVIEW_COUNT : 0,
            'average_rating' : (typeof product.AVERAGE_RATING !== 'undefined' && product.AVERAGE_RATING !== null) ? product.AVERAGE_RATING.toFixed(1) : 0,
            'average_rating_class_suffix' : (typeof product.AVERAGE_RATING !== 'undefined' && product.AVERAGE_RATING !== null) ? product.AVERAGE_RATING.toFixed(1).replace('.' , '_') : '0_0',
            'shade_name' : '',
            'shade_hex' : ''
          };

          // Populate productMap product with sku variations
          for(s = 0; s < product.skus.length; s++) {
            sku = product.skus[s];
            productAlternate = $.extend(true, {}, product);

            // Move found skus to the front of the skus array
            productAlternate.skus = productAlternate.skus.splice(s, 1).concat(productAlternate.skus);

            extended_object.productMap[productID][sku.SKU_ID] = {
              'full' : productAlternate,
              'prod_id' : product.PRODUCT_ID,
              'sku_id' : sku.SKU_ID,
              'quickshop_url' : (typeof product.url !== 'undefined' && product.url !== null) ? product.url : '',
              'image' : (typeof sku.LARGE_IMAGE !== 'undefined' && sku.LARGE_IMAGE !== null) ? sku.LARGE_IMAGE[0] : '',
              'category_id' : (typeof product.DEFAULT_CAT_ID !== 'undefined' && product.DEFAULT_CAT_ID !== null) ? product.DEFAULT_CAT_ID.substr(3) : '',
              'category' :  (typeof product.ATTRIBUTE_COLLECTION !== 'undefined' && product.ATTRIBUTE_COLLECTION !== null) ? product.ATTRIBUTE_COLLECTION : '',
              'name' : (product.PROD_RGN_NAME !== null && product.PROD_RGN_NAME !== null) ? product.PROD_RGN_NAME : '',
              'subhead' : (product.PROD_RGN_SUBHEADING !== null && product.PROD_RGN_SUBHEADING !== null) ? product.PROD_RGN_SUBHEADING : '',
              'alt_description' : (typeof product.ATTRIBUTE_DESC_1 !== 'undefined' && product.ATTRIBUTE_DESC_1 !== null) ? product.ATTRIBUTE_DESC_1 : '',
              'description' : (typeof product.PRODUCT_DETAILS_MOBILE !== 'undefined' && product.PRODUCT_DETAILS_MOBILE !== null) ? product.PRODUCT_DETAILS_MOBILE : '',
              'price' : (typeof sku.formattedPrice !== 'undefined' && sku.formattedPrice !== null) ? sku.formattedPrice : '$0.00',
              'unit_price' : (typeof sku.formattedUnitPrice !== 'undefined' && sku.formattedUnitPrice !== null) ? sku.formattedUnitPrice : '$0.00',
              'review_count' : (typeof product.TOTAL_REVIEW_COUNT !== 'undefined' && product.TOTAL_REVIEW_COUNT !== null) ? product.TOTAL_REVIEW_COUNT : 0,
              'average_rating' : (typeof product.AVERAGE_RATING !== 'undefined' && product.AVERAGE_RATING !== null) ? product.AVERAGE_RATING.toFixed(1) : 0,
              'average_rating_class_suffix' : (typeof product.AVERAGE_RATING !== 'undefined' && product.AVERAGE_RATING !== null) ? product.AVERAGE_RATING.toFixed(1).replace('.' , '_') : '0_0',
              'shade_name' : (typeof sku !== 'undefined' && sku.SHADENAME !== null) ? sku.SHADENAME : '',
              'shade_hex' : (typeof product.skus[s].HEX_VALUE_STRING !== 'undefined' && product.skus[s].HEX_VALUE_STRING !== null) ? product.skus[s].HEX_VALUE_STRING : ''

            };
          }
        }
      }

      // get the li's we need to inject into, ignore the template el-product
      for (var idx = 0; idx < extended_object.wrappers.length; idx++) {
        var $this_wrapper = $(extended_object.wrappers[idx]),
          $these_elproducts = $this_wrapper.find('.el-product');

        // iterate through the el-product elements in the wrapper
        for (var i = 0; i < $these_elproducts.length; i++) {
          var $this_elproduct = $($these_elproducts[i]);
          $targets.push($this_elproduct);
        }
      }

      // inject results
      for(y = 0; y < $targets.length; y++) {
        $this = $($targets[y]);
        productID = $this.data('product');
        sku = $this.data('sku');
        resultData = emptyProductData;

        // Search for results with matching product ID
        if (typeof productID !== 'undefined' && typeof extended_object.productMap[productID] !== 'undefined') {
          resultData = extended_object.productMap[productID].data;
        }

        // Match with SKU
        if (typeof productID !== 'undefined' && typeof sku !== 'undefined' && typeof extended_object.productMap[productID] !== 'undefined' && typeof extended_object.productMap[productID][sku] !== 'undefined') {
          resultData = extended_object.productMap[productID][sku];
        }

        if (extended_object.debug) console.log('elproduct: _handle_rpc_write_success: Injecting results into', $this, resultData);

        if (typeof resultData !== 'undefined') {
          $this.data('full_product_json', resultData.full);
          $this.find(extended_object.class_map.quickshop).data('full_product_json', resultData.full);
          $this.find(extended_object.class_map.image_container).attr('href', resultData.quickshop_url).attr('title', resultData.name);
          $this.find(extended_object.class_map.image).attr('src', resultData.image).attr('alt', resultData.name).data('src', resultData.image);
          $this.attr('data-category-id', resultData.category_id);
          $this.find(extended_object.class_map.quickshop).attr('data-category-id', resultData.category_id);
          $this.find(extended_object.class_map.category).html(resultData.category);
          $this.find(extended_object.class_map.name).attr('href', resultData.quickshop_url).attr('title', resultData.name).html(resultData.name);
          $this.find(extended_object.class_map.subhead).html(resultData.subhead);
          $this.find(extended_object.class_map.alt_description).html(resultData.alt_description);
          $this.find(extended_object.class_map.description).html(resultData.description);
          $this.find(extended_object.class_map.price).html(resultData.price);
          $this.find(extended_object.class_map.unit_price).html(resultData.unit_price);
          $this.find(extended_object.class_map.quickshop).attr('href', resultData.quickshop_url);
          $this.find(extended_object.class_map.review_count).html('(' + resultData.review_count + ')');
          $this.find(extended_object.class_map.rating_star_element).html(resultData.average_rating).attr('title', resultData.average_rating);
          $this.find(extended_object.class_map.rating_star_element).removeClass().addClass('rating_' + resultData.average_rating_class_suffix);
          $this.find(extended_object.class_map.shade_name).html(resultData.shade_name).data('swatch-color', resultData.shade_hex);
        }
      }

      // call back
      if (typeof extended_object.onSuccess === 'function') extended_object.onSuccess();

      // legacy call back
      if (typeof extended_object.callback === 'function')
        extended_object.callback();
    },
    /**
    * _generate_product_list
    * @memberof $.fn.elproduct.methods
    * @function _handle_rpc_write_success
    */
    '_generate_product_list' : function (wrappers, extended_object) {
      var $this_wrapper;
      var $these_elproducts;

      // Adds productIDs to the productMap to populate later
      function processElProduct() {
        var $this = $(this);
        var productID;

        if (typeof $this.data('product') !== 'undefined') {
          productID = $this.data('product');

          // Mark product existence in the productMap
          if (productID.length !== 0 && typeof extended_object.productMap[productID] === 'undefined')
            extended_object.productMap[productID] = {};
        }
      }

      // iterate through wrappers
      for (var idx = 0; idx < wrappers.length; idx++) {
        $this_wrapper = $(wrappers[idx]);
        $these_elproducts = $this_wrapper.find('.el-product');

        $these_elproducts.each(processElProduct);
      }

      // notify
      if (extended_object.debug) {
        console.log('_generate_product_list: product map: ', extended_object.productMap);
      }
    },
    /**
    *
    * Clone the li template as many times as there are products per that wrapper.
    *
    * @memberof $.fn.elproduct.methods
    * @function _create_list_items
    */
    '_create_list_items' : function (extended_object) {
      var $template = $(extended_object.template);
      var productID;
      var skuID;

      // notify
      if (extended_object.debug) {
        console.log('_create_list_items() function');
        console.log('extended object ', extended_object);
        console.log('template ', $template);
      }

      // iterate through wrappers containing el-product elements
      for(var idx = 0; idx < extended_object.wrappers.length; idx++) {
        var $this_wrapper = $(extended_object.wrappers[idx]),
          $this_ul = $this_wrapper.find('ul'),
          this_product_list = $this_wrapper.find(typeof extended_object.products !== 'undefined' ?  extended_object.products : '.el-product_id-list').text().split(',');

        // if we have li's present in the wrapper then we skip cloning elements into it
        if ($this_ul.find('li').length > 0) {
          if (extended_object.debug) console.log('<li>  found inside ' + $this_wrapper.attr('id') + ' so we skip cloning elements inside it.');
        } else {
          // if we dont have li's present in the wrapper then we clone elements into it.
          // iterate through # of items per wrapper, making an <li> for each.
          for (var item = 0; item < this_product_list.length; item++) {
            var ids = this_product_list[item].split(' '),
              $cloned_template = $template.clone(true),
              $cloned_template_shop_button = $cloned_template.find('.el-product_shop-now');

            productID = ids[0];
            skuID = ids.length > 1 ? ids[1] : undefined;

            // update prod and sku attributes on the cloned element, append it to the current wrapper
            if (productID.length !== 0) {
              $cloned_template.data('product', productID); //.attr('data-sku', (ids.length < 2 ) ? '' : ids[1]);
              $cloned_template_shop_button.data('product', productID); //.attr('data-sku', (ids.length < 2 ) ? '' : ids[1]);

              if (typeof skuID !== 'undefined' && skuID.length !== 0) {
                $cloned_template.data('sku', skuID);
                $cloned_template_shop_button.data('sku', skuID);
              }

              if (productID.length !== 0 && typeof extended_object.productMap[productID] === 'undefined')
                extended_object.productMap[productID] = {};
            }

            $this_ul.append($cloned_template);
          }
        }
      }
    }
  };

  /**
  *
  */
  $.fn.elproduct = function () {
    var extended_object,
      callback,
      settings = {},
      $targets = (typeof this === 'function') ? $('body') : $(this); // If we don't provide scope force <body> as scope

    // If no arguments given, notify and return
    if (arguments.length === 0) {
      console.log('Error: No parameters provided to $.fn.elproduct(). You must at least have a specified \'target class\' to search for. Returning now.');
    } else {
      // assign arguments and carry out internal functions
      for (var i = 0; i < arguments.length; i++) {
        switch (typeof arguments[i]) {
          case 'function':
            callback = arguments[i]; // Legacy functionality
            console.log('Warning: A function has been passed in the parameters, onSuccess and onError callbacks need to be part of the object and not separate.');
            break;
          case 'object': // Settings
            settings = arguments[i];
            break;
          case 'undefined': // Ignore undefined
            break;
          case 'string': // Ignore undefined
            break;
          default: // Ignore others
            break;
        }
      }
    }

    // create extended object, assign needed values before running functions.
    extended_object = $.extend({}, defaults, settings);
    extended_object.callback = (typeof callback === 'undefined') ? function() {} : callback; // legacy functionality
    extended_object.wrappers = $targets;

    // debug flag check
    if (typeof extended_object.debug !== 'boolean' || typeof extended_object.debug === 'undefined') extended_object.debug = false;

    // check if the query is okay in the event it is user supplied (usually will never be, though)
    if (typeof extended_object.query !== 'undefined') {
      try {
        JSON.parse(JSON.stringify(extended_object.query));
      } catch (e) {
        if (extended_object.debug) console.log('Error: User-supplied JSON Query is malformed, or another error concerning the query has occurred. Query cannot be performed. Returning now.');
        return $targets;
      }
    }

    // notify
    if (extended_object.debug) {
      console.log('Main elproduct() call');
      console.log($targets);
      console.log(extended_object);
    }

    // create the cloned list items (derived from provided template) per carousel if no li's present.
    methods._create_list_items(extended_object);

    // gather the product IDs from the li's, these will be tossed into the JSON RPC that runs
    methods._generate_product_list($targets, extended_object);

    if (extended_object.debug) console.log('product map', extended_object.productMap);

    // If page_data exists attempt to load in product data based off of such, before running the plugin's main functionality
    // Left over products should be handled after this
    (function() {
      var customMPP,
        productsData,
        p = 0,
        data = [],
        extendedObjectClone = $.extend({}, extended_object);

      if (extended_object.debug) console.log('elproduct: Looking for page_data global variable:', typeof page_data !== 'undefined');

      // Verify that page_data (global var) exists, then if custom-mpp exists
      if (typeof page_data !== 'undefined') {
        customMPP = page_data['custom-mpp'];

        if (extended_object.debug) console.log('elproduct: Looking for page_data customMPP:', typeof customMPP !== 'undefined');

        if (typeof customMPP !== 'undefined') {
          productsData = customMPP['products'];

          // add singular product data to data array
          for(p = 0; p < productsData.length; p++) {
            data.push(productsData[p]);
          }
        }
      }

      if (data.length !== 0) {
        // spoof like we only have prod IDs provided and pass all empty SKUs
        for(p = 0; p < data.length; p++) {
          extendedObjectClone.sku_array.push('');
        }

        // Spoof query success
        methods._post_query_insertion(extendedObjectClone, [{
          result: {
            value: {
              products: data
            }
          }
        }]);
      } else if (extended_object.prod_array.length > 0) {
        // Otherwise query via JSONRPC
        methods._query(extended_object);
      }
    }());
    return $targets;
  };

  // External function aliases
  $.elproduct = $.fn.elproduct;
})(jQuery);